<script>
import toHTML from 'linkifyjs/html';
import moment from 'moment';

import { SectionPostTypes } from '../constants';
import { featuredCampaigns } from '../api/crowdpacs';

export default {
  name: 'CpNewsDetails',
  components: {
    CpBox: require('../box').default,
    CpBoxContent: require('../box-content').default,
    CpGrid: require('../grid').default,
    CpGridItem: require('../grid-item').default,
    CpButton: require('../button').default,
    CpButtonLink: require('../button-link').default,
    CpCommentsPost: require('../comments/box-comments').default,
    LikeActionButton: require('../social-feed/actions/like-action-button').default,
    CpLikesProfiles: require('../likes/likes-profiles').default,
    CpDialog: require('../dialog').default,
    CpSocialShareDialog: require('../dialogs/social-share').default,
    getEmbedUrl: require('../mixins/utils.js').default,
    CpShowInteractionsCount: require('../components/ShowInteractionsCount').default,
    CpShowImageInCard: require('../components/ShowImageInCard').default,
    CpPopularCampaigns: require('../explore-campaigns/components/PopularCampagins').default,
    CpLatestNews: require('./LatestNews').default,
    LobbyActionButton: require('../social-feed/actions/lobby-action-button').default,
    CpLobbyFlowDialog: require('../dialogs/LobbyFlowDialog').default,
    CpStartCampaignPost: require('../social-feed/posts/StartCampaignPost.vue').default,
  },
  directives: {
    marginTop: require('../directives/margins').marginTop,
    marginBottom: require('../directives/margins').marginBottom,
    marginRight: require('../directives/margins').marginRight,
  },
  props: {
    user: Object,
    news: Object,
  },
  data() {
    return {
      comments_count: this.news.comments_count,
      showLikesModal: false,
      explore: true,
      type: SectionPostTypes.NEWS,
      showLobbyDialog: false,
    };
  },
  methods: {
    setCommentsCount() {
      this.comments_count++;
    },
    handleLikesModal() {
      this.showLikesModal = !this.showLikesModal;
    },
    handleCountLikes(value) {
      value ? (this.news.likes_count = this.news.likes_count + 1) : (this.news.likes_count = this.news.likes_count - 1);
    },
    handleLobbyDialog() {
      this.showLobbyDialog = !this.showLobbyDialog;
    },
  },
  computed: {
    content() {
      return toHTML(this.news.content);
    },
    timeAgo() {
      if (this.news.is_scrapping) {
        return moment.utc(this.news.rss_published_at).local().format('L');
      } else {
        return moment.utc(this.news.rss_published_at).local().format('MMM Do hh:mm a');
      }
    },
    videoEmbedUrl() {
      return this.getEmbedUrl(this.news.video_url);
    },
    datePostedFormatted() {
      return moment.utc(this.news.rss_published_at).local().format('MMM. Do hh:mm a');
    },
  },
};
</script>

<template>
  <div>
    <div class="tag-contianer">
      <span class="subheadline1 primary-blue-700-color">News</span>
    </div>
    <cp-grid>
      <cp-grid-item :span="12">
        <div class="H1 black-color text-center">{{ news.title }}</div>
      </cp-grid-item>
      <cp-grid-item v-if="$root.isMobile && news.is_scrapping" :span="12">
        <div class="scrapping-candidate-info">
          <img :src="news.politician_image" class="scrapping-politician-image" />
          <div class="scrapping-text-container">
            <h4 class="heading-4" v-margin-bottom="0">
              {{ news.politician_name }}
            </h4>
            <h5 class="post-time" v-margin-top="0">
              {{ news.political_office }}
            </h5>
          </div>
          <div class="scrapping-donate-button">
            <cp-button-link :href="'/feed'" primary block>Donate</cp-button-link>
          </div>
        </div>
      </cp-grid-item>
      <cp-grid-item :span="12">
        <div v-if="news.video_url" style="text-align: center" class="social-feed-post-profile-wrapper">
          <iframe v-if="videoEmbedUrl !== null" class="video-embed" :src="videoEmbedUrl" allowfullscreen="allowfullscreen" frameborder="0"></iframe>
        </div>
        <div v-else-if="news.image" style="text-align: center" class="social-feed-post-profile-wrapper">
          <CpShowImageInCard :image="news.image" fullWidth />
        </div>
        <p class="body neutral5-color" v-html="content" />
        <div v-if="!news.rss_publisher_url" class="box-url">
          <a :href="news.rss_article_url" target="_blank">Read More</a>
        </div>
        <div class="news-footer">
          <p class="body1 primary-color" v-margin-right="0.5" v-margin-bottom="0">Source: {{ news.rss_publisher_name }}</p>
          <p class="body1 primary-color" v-margin-bottom="0">{{ datePostedFormatted }}</p>
        </div>
      </cp-grid-item>
    </cp-grid>
    <div v-margin-top="2">
      <CpShowInteractionsCount
        :type="type"
        :id="news.id"
        :likesCount="news.likes_count"
        :commentsCount="news.comments_count"
        :handleLikesModal="handleLikesModal"
      />
    </div>

    <cp-dialog v-if="showLikesModal">
      <cp-likes-profiles :count-likes="news.likes_count" :id="parseInt(news.id)" :type="'news'" @close="handleLikesModal"> </cp-likes-profiles>
    </cp-dialog>

    <hr style="margin: 5px !important; width: 100%; display: inline-block" />

    <div class="social-feed-post-actions">
      <div class="post-action-button like">
        <like-action-button type="news" :id="news.id" :liked="news.liked" :onSuccess="handleCountLikes" />
      </div>
      <div class="post-action-button share">
        <cp-social-share-dialog
          class="feed"
          :allow-share-feed="true"
          share-category="News"
          :explore="explore"
          :type="'news'"
          :post="news"
          share-button-class="button--noborder"
          :url="news.permalink_share"
          title="News found via CrowdBlue - Social Network For Politics"
          description="Wanted to share this news I found on CrowdBlue, the Social Network for Politics."
          :quote="news.title"
          hashtags="crowdBlue,politics,political crowdfunding"
          twitter-user="crowdblue"
        ></cp-social-share-dialog>
      </div>
      <div class="post-action-button like">
        <LobbyActionButton :handleLobbyDialog="handleLobbyDialog" title="Contact My Reps" />
      </div>
    </div>

    <cp-comments-post :id="news.id" :type="type" :setCount="setCommentsCount" displayCommentInput style="margin-bottom: 50px" />

    <div v-if="$root.isMobile" v-margin-bottom="1">
      <CpLatestNews :newsId="news.id" />
    </div>

    <CpPopularCampaigns />

    <div class="bottom-items" v-margin-top="1">
      <CpStartCampaignPost class="start-campaign-post" />
    </div>

    <CpLobbyFlowDialog
      v-if="showLobbyDialog"
      :showDialog="showLobbyDialog"
      type="none"
      customSubject="Concern over government spending"
      :newsArticle="news"
      :callback="handleLobbyDialog"
      shareMessageInComments
      :originalPostType="type"
      :originalPostId="news.id"
      @close="handleLobbyDialog"
    />
  </div>
</template>
<style scoped>
.tag-contianer {
  display: flex;
  justify-content: flex-end;
}
.news-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}
.post-time {
  color: #666;
  text-decoration: none;
  font-size: 0.9em;
  font-weight: 400;
}
.box-url {
  margin-bottom: 10px;
}
.social-feed-post-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 7px 0px;
}
.post-action-button.like,
.post-action-button.share {
  width: auto;
  border-radius: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
}
.scrapping-candidate-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 8px;
}
.scrapping-politician-image {
  border-radius: 100px;
  width: 104px;
  height: 104px;
}
.scrapping-donate-button {
  width: 100%;
}
.video-embed {
  width: 100%;
  min-height: 450px !important;
  aspect-ratio: 16 / 9;
}
.bottom-items {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.start-campaign-post {
  max-width: 300px;
}
@media only screen and (max-width: 767px) {
  .scrapping-candidate-info {
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: auto;
    padding: 8px;
    border-radius: 4px;
  }
  .scrapping-politician-image {
    width: 40px;
    height: 40px;
  }
  .scrapping-text-container {
    flex: 3;
    padding-left: 8px;
  }
  .scrapping-donate-button {
    flex: 1;
    width: auto;
  }
}
@media screen and (max-width: 500px) {
  .news-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
